import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './th-tooltip.scss';

const RIGHT = 'right';
const CENTER = 'center';
const LEFT = 'left';

class ThTooltip extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      top: null,
      left: null,
      className: '',
    };
    this.el = document.createElement('div');
    this.el.style.position = 'absolute';

    this.tooltipRef = React.createRef();
    this.rootRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShow } = this.state;
    if (isShow && !prevState.isShow) {
      const { top, left } = this.getTooltipPos();
      const className = this.getTheadTextAlign();
      const { triangleTop, triangleLeft } = this.getTrianglePos();
      this.setState({
        top,
        left,
        className,
        triangleTop,
        triangleLeft,
      });
    }
  }

  onMouseWheel = () => {
    const { isShow } = this.state;
    if (isShow) {
      this.hideTooltip();
    }
  };

  isOuterRight = () => {
    const align = getComputedStyle(this.rootRef.current).textAlign;
    const { left, width, right } = this.rootRef.current.getBoundingClientRect();
    const tableDom = this.rootRef.current.closest('.scrollbars');
    const { right: tableRight } = tableDom.getBoundingClientRect();
    const {
      width: tooltipWidth,
    } = this.tooltipRef.current.getBoundingClientRect();
    if (align === LEFT) {
      return left + tooltipWidth > tableRight;
    }

    if (align === CENTER) {
      return left + width / 2 + tooltipWidth > tableRight;
    }

    return right > tableRight;
  };

  getTheadTextAlign = () => {
    if (!this.rootRef.current || !this.tooltipRef.current) {
      return '';
    }
    if (this.isOuterRight()) {
      return RIGHT;
    }
    return this.rootRef.current
      ? getComputedStyle(this.rootRef.current).textAlign
      : '';
  };

  getTrianglePos = () => {
    const align = this.getTheadTextAlign();
    const {
      left: rootLeft,
      width: rootWidth,
      top: rootTop,
      right: rootRight,
    } = this.rootRef.current.getBoundingClientRect();
    const paddingLeft = 20;
    const paddingTop = 8;
    const { right: wrapperRight } = this.rootRef.current
      .closest('.scrollbars ')
      .getBoundingClientRect();

    if (align === LEFT) {
      return {
        triangleLeft: rootLeft + paddingLeft,
        triangleTop: rootTop - paddingTop,
      };
    }

    if (align === RIGHT) {
      return {
        triangleLeft: Math.min(wrapperRight, rootRight) - paddingLeft,
        triangleTop: rootTop - paddingTop,
      };
    }

    return {
      triangleLeft: rootLeft + rootWidth / 2 - 4,
      triangleTop: rootTop - paddingTop,
    };
  };

  getRealLeft = left => {
    const { left: wrapperLeft } = this.rootRef.current
      .closest('.scrollbars')
      .getBoundingClientRect();

    return Math.max(left, wrapperLeft);
  };

  getTooltipPos = () => {
    const {
      top,
      left,
      width: rootWidth,
    } = this.rootRef.current.getBoundingClientRect();
    const {
      height: tooltipHeight,
      width: tooltipWidth,
    } = this.tooltipRef.current.getBoundingClientRect();
    const align = this.getTheadTextAlign();
    const tooltipTop = top - tooltipHeight - 6;
    if (this.isOuterRight()) {
      const { right: tableRight } = this.rootRef.current
        .closest('.scrollbars')
        .getBoundingClientRect();
      return {
        left: this.getRealLeft(tableRight - tooltipWidth),
        top: tooltipTop,
      };
    }

    if (align === RIGHT) {
      return {
        left: this.getRealLeft(left + rootWidth - tooltipWidth),
        top: tooltipTop,
      };
    }

    if (align === CENTER) {
      return {
        left: this.getRealLeft(left + (rootWidth - tooltipWidth) / 2),
        top: tooltipTop,
      };
    }

    return {
      left: this.getRealLeft(left),
      top: tooltipTop,
    };
  };

  showTooltip = () => {
    document.body.appendChild(this.el);
    window.addEventListener('wheel', this.onMouseWheel);
    this.setState({
      isShow: true,
    });
  };

  hideTooltip = () => {
    this.setState({
      isShow: false,
    });
    document.body.removeChild(this.el);
    window.removeEventListener('wheel', this.onMouseWheel);
  };

  onMouseEnter = () => {
    //this.showTooltip();
  };

  onMouseLeave = () => {
    const { isShow } = this.state;
    if (isShow) {
      this.hideTooltip();
    }
  };

  renderTooltip = () => {
    const { top, left, className, triangleLeft, triangleTop } = this.state;
    const { tooltip } = this.props;

    return (
      <div
        ref={this.tooltipRef}
        style={{
          top: top ? top : 9999,
          left: left ? left : 9999,
          position: 'fixed',
        }}
        className="th-tooltip-content"
      >
        <div className={`tooltip-content-inner ${className}`}>
          {tooltip}
          <div
            className="triangle"
            style={{ position: 'fixed', left: triangleLeft, top: triangleTop }}
          />
        </div>
      </div>
    );
  };

  render() {
    const { isShow } = this.state;
    const { children } = this.props;
    return (
      <div className="portal-tooltip position-relative">
        <div
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          className="portal-tooltip-inner"
          ref={this.rootRef}
        >
          {children}
        </div>

        {isShow && ReactDOM.createPortal(this.renderTooltip(), this.el)}
      </div>
    );
  }
}

ThTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

export default ThTooltip;
